document.querySelectorAll(".brewing-tip").forEach(function (element) {
  element.addEventListener("click", function () {
    var tipText = this.querySelector(".tip-text");
    if (tipText.style.display === "block") {
      tipText.style.display = "none";
    } else {
      tipText.style.display = "block";
    }
  });
});
